export function getCadeModeForName(authUserType, forUserType, rater1Name="Rater 1", rater2Name = "Rater 2", rater3Name="Rater 3") {
    let raterName = null;
    switch (forUserType) {
        case 1:
            raterName = (authUserType == forUserType) ? "Your" : "Clinician";
            break;

        case 2:
            raterName = (authUserType == forUserType) ? "Your" : "CADE User";
            break;

        case 3:
        case 6:
            raterName = (rater3Name == null) ? "Rater 3" : rater3Name;
            break;

        case 4:
            raterName = (rater1Name == null) ? "Rater 1" : rater1Name;
            break;

        case 5:
            raterName = (rater2Name == null) ? "Rater 2" : rater2Name;
            break;

        default:
            // Can't happen (clinicians can see everyone, parents can only see raters)
            break;
    }

    return raterName;
}


// WEBPACK FOOTER //
// ./src/helpers/CadeComponentHelpers.js